/**
 * @deprecated
 * 带ui的组件基类
 */
'use strict';
define([
    './ComponentBase',
    '../utils/CommonUtil',
    '../utils/ResourceUtil',
    './ContainerManager'

],function(
    ComponentBase,
    CommonUtil,
    ResourceUtil,
    ContainerManager
){
    /**
     * 组件初始化构造方法
     * @ignore
     * @constructor
     * @classdesc 带ui的组件基类
     * @alias G.base.UiComponent
     * @augments G.base.ComponentBase
     * @param {Object} options - 必填，构造参数对象
     * @returns {Class} 实例化对象
     */
    var component=ComponentBase.extend({
        //默认配置项
        options:{
            //地图对象
            map:null,
            //html目录
            htmlPath:'',
            //样式目录
            cssPath:'',
            //需要加载的css文件名（cssPath目录下），多个为数组
            cssName:''
        },

        includes: ContainerManager.prototype,
        initialize:function(options){
            ComponentBase.prototype.initialize.call(this,options);
            //样式、html相对目录
            this._cssPath=options.cssPath;
            this._htmlPath=options.htmlPath;
            /**
             * ui依赖的样式
             * @type {Array}
             */
            var cssName=this.options.cssName;
            if(cssName){
                var cssArr=[];
                if(CommonUtil.isArray(cssName)){
                    for(var i=0,len=cssName.length;i<len;i++){
                        cssArr.push(this._cssPath+cssName[i]);
                    }
                }else if(CommonUtil.isString(cssName)){
                    cssArr.push(this._cssPath+this.options.cssName);
                }
                //加载样式
                ResourceUtil.loadCss(cssArr);
            }
        },

        /**
         * 销毁，对应initialize
         * @method
         * @memberOf G.base.UiComponent.prototype
         */
        destroy:function(){
            try{
                this.remove();
            }catch(e){}
            //
            ComponentBase.prototype.destroy.call(this);
        }
    });

    /**
     * 常用的一些封装
     */
    component.include({
        /**
         * 加载html片段
         * @method
         * @memberOf G.base.UiComponent.prototype
         * @param $obj {jQuery/String} 必填，父容器jquery对象，或者jQuery选择器
         * @param url {String} 必填，html片段url
         * @param callback {Function} 可选，加载完成的回调，回调上下文对象为当前对象
         */
        loadHtml:function($obj,url,callback){
            var self=this;
            jQuery($obj).load(url,function(){
                if(CommonUtil.isFunction(callback)){
                    callback.call(self);
                }
            });
        }
    });
    return component;
})
